export default __webpack_public_path__ + "static/media/area2_960.d6811629.webp";